'use es6';

import http from 'hub-http/clients/apiClient';
export const fetchCreateAndOwnHubUsers = () => http.get(`users/v2/app/scopes/reporting-create-and-own/hub-users`);